import CalendarModeBaseView from './CalendarModeBaseView';
import EventsCalendarViewMode from './EventsCalendarViewMode';
import DateFormatter from '../date/EventListingDateFormatter';
import EventMonthTable from './html/EventMonthTable';
import EventMonthList from './html/EventMonthList';
import {
  firstOfMonth,
  lastOfMonth,
  startOfWeek,
  endOfWeek,
  endOfDay,
} from '../date/DateHelpers';


class CalendarMonthView extends CalendarModeBaseView {
  constructor(store, config) {
    super(
      store,
      config,
      EventsCalendarViewMode.MONTH,
    );

    this.setResultViews([
      new EventMonthTable(),
      new EventMonthList(),
    ]);
  }

  async initDatepicker(DatePicker, { date, minDate, maxDate }) {
    this.datePicker = new DatePicker({
      date,
      minDate,
      maxDate,
      id: 'tn-event-calendar-input-month',
      label: 'Select Month',
      rangeType: DatePicker.RangeType.MONTH,
      dateFormatter: DateFormatter.month,
      onChange: this.onDateChange.bind(this),
    });
  }

  getRangeForSelectedDate() {
    const { selectedDate: date } = this;

    return {
      startDate: startOfWeek(firstOfMonth(date)),
      endDate: endOfDay(endOfWeek(lastOfMonth(date))),
    };
  }
}

export default CalendarMonthView;
